export default "__VITE_PUBLIC_ASSET__67b84c58__"